module.exports = __webpack_public_path__ + "static/media/vibrate.a4be6868.svg";


//////////////////
// WEBPACK FOOTER
// ./src/vibrate.svg
// module id = 26
// module chunks = 0